import type { EducationSubTab } from './EducationHub'

export function parseEduTabParam(search: string): EducationSubTab | null {
  if (!search) return null
  const params = new URLSearchParams(search)
  const tab = params.get('tab') ?? (search === 'attendance' || search === 'work' || search === 'timetable' || search === 'bookings' || search === 'feed' || search === 'messages' || search === 'admissions' ? search : null)
  if (tab === 'attendance') return 'ATTENDANCE'
  if (tab === 'work') return 'WORK'
  if (tab === 'timetable') return 'TIMETABLE'
  if (tab === 'bookings') return 'BOOKINGS'
  if (tab === 'feed') return 'FEED'
  if (tab === 'messages') return 'MESSAGES'
  if (tab === 'admissions') return 'ADMISSIONS'
  return null
}

export function parseEduEnquiryParam(search: string): string | null {
  if (!search) return null
  return new URLSearchParams(search).get('enquiry')
}

export function parseEduEventParam(search: string): string | null {
  if (!search) return null
  return new URLSearchParams(search).get('event')
}

export function parseEduPtmDayParam(search: string): string | null {
  if (!search) return null
  return new URLSearchParams(search).get('ptmDay')
}

